export enum RoutePaths {
  login = '/login',
  logout = '/logout',
  accessForbidden = '/403',
  memberAccessForbidden = '/403-member',
  serverError = '/500',
  notFound = '/*',
  dashboard = '/',
  dataHub = '/data-hub',
  massUpload = '/data-hub/tools/mass-upload',
  dataHubSearchParams = '/data-hub/search-params',
  dataHubChildren = '/data-hub/:category',
  dataHubCbam = '/data-hub/cbam',
  toolboxMpnSearch = '/toolbox/mpn-search',
  toolboxStandardParts = '/toolbox/standard-parts',
  toolboxElectronicsV2 = '/toolbox/electronics-v2',
  toolboxLcaGenerator = 'toolbox/lca-generator',
  toolboxStandardPartsDetails = '/toolbox/standard-parts/details/:sid',
  toolboxElectronicsV2Details = '/toolbox/electronics-v2/details/:sid',
  singleEntity = '/entity/:id',
  automationHub = '/management/automation-hub',
  toolboxAssembler = '/toolbox/assembler',
  toolboxMatcher = '/toolbox/matcher',
  toolboxCollector = '/toolbox/collector',
  toolbox = '/toolbox',
  toolboxInterpreter = '/toolbox/interpreter',
  toolboxAssemblerCompare = '/toolbox/assembler/compare-assemblies',
  toolboxAssemblerCalculationSteps = '/toolbox/assembler/calculation-steps',
  toolboxAssemblerMyAssemblies = '/toolbox/assembler/my-assemblies',
  organizationManagement = '/management/organization-management',
  subscriptionManagement = '/management/subscription-management',
  dataCenter = '/tools/data-center',
  simulationCenter = '/tools/simulation-center',
  scope12Calculator = '/tools/scope-12-calculator',
  procurementCenter = '/tools/procurement-center',
  knowledgeHub = 'docs.sustamizer.com',
  knowledgeHubDatabaseOverview = 'https://docs.sustamizer.com/knowledge-hub/releases/releases-and-changes',
  knowledgeHubCalculationVariants = 'docs.sustamizer.com/knowledge-hub/database-overview/materials',
  knowledgeHubDataQualityAssurance = 'docs.sustamizer.com/knowledge-hub/data-quality',
  knowledgeHubElectronics = 'docs.sustamizer.com/knowledge-hub/database-overview/electronics',
  knowledgeHubEnergy = 'docs.sustamizer.com/knowledge-hub/database-overview/energy',
  knowledgeHubConsumerProducts = 'docs.sustamizer.com/knowledge-hub/database-overview/consumer-products',
  knowledgeHubLogistics = 'docs.sustamizer.com/knowledge-hub/database-overview/logistics',
  knowledgeHubMaterials = 'docs.sustamizer.com/knowledge-hub/database-overview/materials',
  knowledgeHubProduction = 'docs.sustamizer.com/knowledge-hub/database-overview/production',
  helpSupport = '/help/support',
  upgrade = '/upgrade',
  organizationProfile = '/user/organization-profile',
  userSettings = '/user/settings',
  comingSoon = '/coming-soon',
  comingSoonId = '/coming-soon/:id',
  termsAndConditions = '/terms-and-conditions',
  privacyPolicy = '/privacy-policy',
  imprint = '/imprint',
  billing = '/user/billing',
  dataAsServiceAggrement = '/data-as-service-aggrement'
}
